import { API_URL } from './apiDictionary';
import { throttle } from 'lodash';
import { PaginatedResponse } from '@dynamika-shared/types/general';
import {
  fetchSubjectListMock,
  fetchSubjectDetailsMock,
} from './mocks/siteSubjects';
import {
  SiteSubjectType,
  SiteSubjectDetails,
} from '@dynamika-shared/types/subjects';
import { SiteSubjectTypeForm } from '@components/modals/SubjectCreate/SubjectCreate';
import { RESTClient, RESTClientMock } from './client';
import { USE_API_MOCKS } from '../env';
import { prepareUrl } from 'src/utils/routerHelpers';

const api = USE_API_MOCKS ? RESTClientMock : RESTClient;

type PaginatedArgs = {
  page?: number;
  size?: number;
  sort?: string;
};

type SubjectDetailsPropsType = {
  clinicalTrialId: string;
  patientId: string;
  siteId: string;
};

export const fetchSubjectsBySite = throttle(
  async (
    siteId: string,
    ctId: string,
    args?: PaginatedArgs,
    patientCode?: string
  ) => {
    if (USE_API_MOCKS) {
      fetchSubjectListMock(siteId, args);
    }

    try {
      const response = await api.get<PaginatedResponse<SiteSubjectType>>(
        API_URL.subjectList,
        {
          params: {
            patientCode,
            page: args?.page ? args?.page - 1 : 0,
            size: args?.size ?? 10,
            sort: args?.sort,
            siteId: siteId,
          },
          headers: {
            'x-dynamika-clinical-trial-id': ctId,
            'x-dynamika-site-id': siteId,
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error('Error fetching subjects by site:', error);
      throw error;
    }
  }
);

export const createSubject = async (
  body: SiteSubjectTypeForm,
  ctId: string,
  siteId: string
) => {
  return api.post<SiteSubjectType>(API_URL.subject, body, {
    headers: {
      'x-dynamika-clinical-trial-id': ctId,
      'x-dynamika-site-id': siteId,
    },
  });
};

export const getSubjectDetails = async ({
  clinicalTrialId,
  patientId,
  siteId,
}: SubjectDetailsPropsType) => {
  if (USE_API_MOCKS) {
    fetchSubjectDetailsMock(clinicalTrialId);
  }

  try {
    return api.get<SiteSubjectDetails>(
      prepareUrl(API_URL.subjectDetail, [patientId]),
      {
        headers: {
          'x-dynamika-clinical-trial-id': clinicalTrialId,
          'x-dynamika-site-id': siteId,
        },
      }
    );
  } catch (error) {
    console.error('Error fetching subject details: ', error);
  }
};
